import api from '../../../../../api/axios';
import {
  mockCurrentOrders,
  mockActivities,
  mockSummary,
  mockCalendar,
  mockRevenue,
  mockReceipt,
  mockManagement,
  mockCashier,
  mockCashierStats
} from '../mockData';




export const fetchSummary = async () => {
  const { data } = await api.get("/pms/pos/revenue/summary");
  return data;
};

export const fetchActivities = async () => {
  const { data } = await api.get("/pms/pos/revenue/activities");
  return data;
};

export const fetchRevenue = async () => {
  const { data } = await api.get("/pms/pos/revenue/heatmap");
  return data;
};

export const fetchManagement = async () => {
  const { data } = await api.get("/pms/pos/revenue/transactions");
  return data;
};


export async function fetchCurrentOrders() {
  return Promise.resolve(mockCurrentOrders);
}

// export async function fetchActivities() {
//   return Promise.resolve(mockActivities);
// }

// export async function fetchSummary() {
//   return Promise.resolve(mockSummary);
// }

export async function fetchCalendar() {
  return Promise.resolve(mockCalendar);
}

// export async function fetchRevenue() {
//   return Promise.resolve(mockRevenue);
// }

export async function fetchReceipt() {
  return Promise.resolve(mockReceipt);
}

// export async function fetchManagement() {
//   return Promise.resolve(mockManagement);
// }

export async function fetchCashier() {
  return Promise.resolve(mockCashier);
}

export async function fetchCashierStats() {
  return Promise.resolve(mockCashierStats);
}
